import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganisationIATADetail } from '../../../../../Redux/action/Organisation/OrganisationListAction';
import useSelection from 'antd/es/table/hooks/useSelection';

const EditIATA = ({ show, handleClose, refreshIATA, airlineOptions, token, user_id, b64id, iata_organisation_id }) => {

    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const dispatch = useDispatch();
    const initialValues = {
        airline: "",
        airline_id: "",
        account_no: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: values => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.customer_id = atob(b64id);
                values.id = iata_organisation_id;
                axios.post(`${adminMainUrl}/api/organization/iata/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refreshIATA();
                            handleClose();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });


    useEffect(() => {
        if (iata_organisation_id) {
            dispatch(getOrganisationIATADetail(token, user_id, iata_organisation_id))
        }
    }, [iata_organisation_id])

    const { loadingOrganisationIATADetail, OrganisationIATADetail, OrganisationIATADetailError } = useSelector(state => state?.OrganisationListReducer);

    useEffect(() => {
        if (loadingOrganisationIATADetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (OrganisationIATADetail) {
            // formik.setFieldValue("airline", Number(OrganisationIATADetail?.));
            formik.setFieldValue("airline_id", Number(OrganisationIATADetail?.airline_id));
            formik.setFieldValue("account_no", (OrganisationIATADetail?.account_no));
        }
    }, [loadingOrganisationIATADetail, OrganisationIATADetail]);

    const customStyles = {
        control: (base) => ({
          ...base,
          height: 29,
          minHeight: 29,
          display: 'flex',
          alignItems: 'center',
        }),
        placeholder: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          fontSize: '12px',
          fontWeight: "600",
          color: '#808080',
        }),
        menu: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        option: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: '12px',
          display: 'flex', // Ensure singleValue aligns center vertically
          alignItems: 'center',
        }),
      };


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement='end' name="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit IATA</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="col-md-12">
                                <label htmlFor="airline" className="form-label">Airline</label>
                                <Select
                                    name="airline_id"
                                    className='custom-selector'
                                    options={airlineOptions}
                                    styles={customStyles}
                                    value={airlineOptions.find(option => option.value === formik.values.airline_id) || null}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("airline_id", selectedOption.value);
                                        formik.setFieldValue("airline", selectedOption.label);
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="airline" className="form-label">Account No.</label>
                                <input
                                    type='text'
                                    className='form-control form-control-sm'
                                    maxLength={50}
                                    id="account_no"
                                    name="account_no"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.account_no}
                                />
                            </div>
                            <div className="col-md-12 text-end mt-2">
                                <button className="btn btn-submit btn-danger">Submit</button>
                            </div>
                        </form>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditIATA